import React from "react";
import _join from "lodash/join";
import _compact from "lodash/compact";
import { useTranslation } from "i18n";
import useGetReps from "pages/Profile/hooks/useGetReps";

const RepsPrint = () => {
  const { t } = useTranslation();
  const {
    agents = [],
    schools = [],
    isSelfRepresented,
    isLookingForRepresentation,
  } = useGetReps();

  const agentLists = [
    ...agents,
    ...schools.map((school) => ({
      ...school,
      name: t("performer:profile.training.title.named", { name: school.name }),
    })),
  ];

  return (
    <div className="grid grid-cols-3 gap-4">
      {isSelfRepresented && (
        <div>
          <p className="mb-0.5 text-xs font-bold uppercase">
            {t("performer:profile.representation.selfRepresented")}
          </p>
          {isLookingForRepresentation && (
            <p className="text-xs">
              {t("performer:profile.representation.seekingRepresentation")}
            </p>
          )}
        </div>
      )}

      {agentLists.map((agent) => {
        const address = _join(
          _compact([
            agent.address?.addressLine1,
            agent.address?.addressLine2,
            agent.address?.addressLine3,
            agent.address?.addressLine4,
            agent.address?.country,
            agent.address?.postCode,
          ]),
          ", "
        );

        return (
          <div key={agent.refNumber}>
            <p className="text-xs font-bold uppercase">{agent.name}</p>
            {address && <p className="text-xs">{address}</p>}
            {agent.phone && (
              <p className="text-xs">
                {t("common:label.tel")}: {agent.phone}
              </p>
            )}
            {agent.email && <p className="text-xs">{agent.email}</p>}
            {agent.website && <p className="text-xs">{agent.website}</p>}
          </div>
        );
      })}
    </div>
  );
};

export default RepsPrint;
